import React from 'react';
import * as ThemeUI from 'theme-ui';
import { foundations } from './foundations';
import { variants } from './variants';

export const ThemeProvider = ({ children }) => (
  <ThemeUI.ThemeProvider theme={{ ...foundations, ...variants }}>
    {children}
  </ThemeUI.ThemeProvider>
);
